var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 381 381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.8,133.9C78,157.7,55,179.8,46.2,205.4C6.5,311.3,152.1,379.3,153,380.1c0.9,0,1.8,0.9,2.6,0.9c1.8,0,3.5-0.9,4.4-2.6 c1.8-2.6,0.9-5.3-1.8-7.1c-24.7-16.8-34.4-40.6-25.6-64.4c5.3-15.9,16.8-28.2,30.9-34.4c14.1-6.2,36.2-7.1,53.8,1.8 c13.2,7.1,20.3,18.5,22.9,35.3c4.4,29.1-15,54.7-15,54.7c-1.8,1.8-1.8,4.4,0,6.2c1.8,1.8,3.5,2.6,5.3,2.6 c20.3-3.5,114.7-53,114.7-143c0-97.1-101.5-189.7-161.5-229.5c-1.8-0.9-4.4-0.9-6.2,0s-2.6,3.5-2.6,5.3c4.4,19.4-5.3,40.6-15,58.2 C145.9,89.8,123.9,111.9,101.8,133.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatIcon);
export default __webpack_public_path__ + "static/media/heat-icon.a2ead9c2a8886c924fa84ff095b865a8.svg";
export { ForwardRef as ReactComponent };